import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import ButtonLink from '../common/ButtonLink';

import commonStyles from '../common/Styles';

const styles = (theme) => commonStyles(theme);

class RecoverComplete extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes.form}>
        {this.props.text.split('\n').map((item, key) => <p className={classes.text} key={key}>{item}</p>)}
        <div
          className={classes.actionButtons}>
          <ButtonLink
            className="to-right"
            color="secondary"
            variant="contained"
            to="/"
            onClick={this.props.onComplete}>Login</ButtonLink>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(RecoverComplete)



// WEBPACK FOOTER //
// ./src/components/RecoverComplete/index.js